import React, { useCallback, useEffect, useState, useMemo } from 'react'
import { Link as RouterLink, useParams } from 'react-router-dom'
import { makeStyles } from '@material-ui/styles'
import { Card, CardContent, Typography, Divider, Link } from '@material-ui/core'
import { Page } from 'components'
import { Formulario } from './components'
import { ThemeProvider } from '@material-ui/styles'
import { CssBaseline } from '@material-ui/core'
import { getTheme } from '../../theme'

const useStyles = makeStyles((theme) => ({
  root: {
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(6, 8),
  },
  card: {
    width: '30%',
    maxWidth: '100%',
    overflow: 'unset',
    display: 'flex',
    position: 'relative',
    '& > *': {
      flexGrow: 1,
      flexBasis: '50%',
      width: '50%',
    },
  },
  content: {
    padding: theme.spacing(8, 4, 3, 4),
  },
  media: {
    borderTopRightRadius: 4,
    borderBottomRightRadius: 4,
    padding: theme.spacing(3),
    color: theme.palette.white,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-end',
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },
  profile: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    minHeight: 'fit-content',
  },
  name: {
    marginTop: theme.spacing(1),
  },
  logo: {
    marginBottom: theme.spacing(2),
  },
  loginForm: {
    marginTop: theme.spacing(3),
  },
  divider: {
    margin: theme.spacing(2, 0),
  },
  person: {
    marginTop: theme.spacing(2),
    display: 'flex',
  },
  avatar: {
    marginRight: theme.spacing(2),
  },
}))

export const RedefinirSenha = (props) => {
  const lightTheme = useMemo(() => getTheme(false), [])

  return (
    <ThemeProvider theme={lightTheme}>
      <CssBaseline />
      <RedefinirSenhaContent {...props} />
    </ThemeProvider>
  )
}

export const RedefinirSenhaContent = (props) => {
  const classes = useStyles()

  const { token } = useParams()

  return (
    <Page className={classes.root} title="Redefinir senha - SIGEP">
      <Card className={classes.card}>
        <CardContent className={classes.content}>
          <div className={classes.profile}>
            <div className={classes.logo} >
              <img
                src={"/images/logos/logo-sigep.png"}
                alt="Logo do SIGEP"
                width={"300px"}
              />
            </div>
            
            <Typography gutterBottom variant="h3">
              Redefinir Senha
            </Typography>
          </div>

          <Formulario token={token} className={classes.loginForm} />
          <Divider className={classes.divider} />
          <Link
            align="center"
            color="secondary"
            component={RouterLink}
            to="/auth/login"
            underline="always"
            variant="subtitle2"
          >
            Voltar a tela de login
          </Link>
        </CardContent>
      </Card>
    </Page>
  )
}
